export default __webpack_public_path__ + "static/media/StylifyRed1.f7f07d35.png";